const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.B2B_CLIENTS)

export const apiB2bClients = {
	fetchB2bClients: async ({
		page = 1,
		perPage = 25,
		search,
		sortField,
		sortOrder,
	}: {
		page?: number
		perPage?: number
		search?: string
		sortField?: string
		sortOrder?: 'asc' | 'desc'
	} = {}): Promise<IApiResponseModel<IB2bClientListItemModel[]>> => {
		const sort = sortField
			? { [sortField]: sortOrder === 'desc' ? EApiSortType.DESC : EApiSortType.ASC }
			: undefined
		const { data, meta } = await apiCommon<IB2bClientDto[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(buildPagination(page, perPage), { search }, sort),
		})
		return { data: data.map(B2bClientListItem), meta }
	},

	fetchAllB2bClients: async (): Promise<IB2bClientListItemModel[]> => {
		const { data } = await apiCommon<IB2bClientDto[]>(`${groupPrefix}/all`, { method: 'GET' })
		return data.map(B2bClientListItem)
	},

	createB2bClient: async (payload: IB2bClientCreatePayload): Promise<IB2bClientListItemModel> => {
		const { data } = await apiCommon<IB2bClientDto>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})
		return B2bClientListItem(data)
	},

	updateB2bClient: async (id: number, payload: IB2bClientUpdatePayload): Promise<IB2bClientListItemModel> => {
		const { data } = await apiCommon<IB2bClientDto>(`${groupPrefix}/${id}`, {
			method: 'PATCH',
			body: payload,
		})
		return B2bClientListItem(data)
	},

	deleteB2bClient: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},

	fetchB2bClientUsers: async (
		b2bClientId: number,
		{ page = 1, perPage = 25 }: { page?: number; perPage?: number } = {},
	): Promise<IApiResponseModel<IB2bClientUserModel[]>> => {
		const { data, meta } = await apiCommon<IB2bClientRegistrationSnapshotDto[]>(
			`${groupPrefix}/${b2bClientId}/registered-clients`,
			{
				method: 'GET',
				...createQuery(buildPagination(page, perPage)),
			},
		)
		return { data: data.map(B2bClientUser), meta }
	},
}
